"use strict";

// MV Crossfade
const section = document.getElementById('fade');
const mv = section?.querySelector('.fuwanmel--mv--movie');
const logo = section?.querySelector('.fuwanmel--mv--movie--logo');
const title = section?.querySelector('.fuwanmel--mv--title');

const mqlMobile = window.matchMedia('(max-width: 768px)'); // モバイルと判定する画面幅
const isMobile = () => mqlMobile.matches; // モバイル判定

const clamp01 = (n) => Math.min(1, Math.max(0, n));
let ticking = false;
let enabled = false;

const update = () => {
  ticking = false;

  const rect = section.getBoundingClientRect();
  const viewHeight = (window.visualViewport?.height ?? window.innerHeight) - 87.5;

  const scrollRange = section.offsetHeight - viewHeight;
  const progressed = scrollRange > 0 ? (-rect.top / scrollRange) : 0;

  const fadeProgress = clamp01(progressed);
  const safeDistance = Math.max(0, viewHeight);

  const ease = (x) => x * x * (3 - 2 * x); // smoothstep

  // 動画を消すタイミング
  const MV_FADE_END = 0.8;
  const mvProgress = clamp01(fadeProgress / MV_FADE_END);
  const mvEasing = ease(mvProgress);

  // タイトル部分
  const titleEasing = ease(fadeProgress);

  // ロゴはスクロール開始すぐ消える
  logo.style.opacity = fadeProgress > 0.1 ? 0 : 1;

  // 動画は全体の進捗の半分で消える
  mv.style.opacity = String(1 - mvEasing);

  title.style.opacity = String(titleEasing);
  title.style.transform = `translateY(${(1 - fadeProgress) * safeDistance}px)`;

  mv.style.pointerEvents = fadeProgress > MV_FADE_END ? 'none' : 'auto';
  title.style.pointerEvents = fadeProgress > MV_FADE_END ? 'auto' : 'none';
};

const onScroll = () => {
  if (ticking) return;
  ticking = true;
  requestAnimationFrame(update);
};

const enableCrossFade = () => {
  if (enabled) return;
  enabled = true;

  document.documentElement.classList.add('js', 'fade-enabled');

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  update();
};

const disableCrossFade = () => {
  if (!enabled) return;
  enabled = false;

  window.removeEventListener('scroll', onScroll);
  window.removeEventListener('resize', onScroll);

  mv.style.opacity = '';
  title.style.opacity = '';
  mv.style.pointerEvents = '';
  title.style.pointerEvents = '';

  document.documentElement.classList.remove('fade-enabled');
};

const apply = () => {
  if (isMobile()) enableCrossFade(); // モバイル時のみ適用
  else disableCrossFade();
};

apply(); // 初期判定
mqlMobile.addEventListener?.('change', apply); // 画面幅の変更を検知

// Swiper JS settings
const swiper1 = new Swiper(".swiper-bed", {
  centeredSlides: true,
  slidesPerView: 1.85,
  spaceBetween: 20,
  loop: true,
  roundLengths: true,
  pagination: {
    el: ".pagination-bed",
    clickable: true,
  },
  navigation: {
    nextEl: ".next-bed",
    prevEl: ".prev-bed",
  },
  breakpoints: {
    768: {
      slidesPerView: 4.3,
      spaceBetween: 30,
      centeredSlides: false,
      loop: false,
    }
  }
});

const swiper2 = new Swiper(".swiper-wear", {
  centeredSlides: true,
  slidesPerView: 1.85,
  spaceBetween: 20,
  loop: true,
  roundLengths: true,
  pagination: {
    el: ".pagination-wear",
    clickable: true,
  },
  navigation: {
    nextEl: ".next-wear",
    prevEl: ".prev-wear",
  },
  breakpoints: {
    768: {
      slidesPerView: 4.3,
      spaceBetween: 30,
      centeredSlides: false,
      loop: false,
    }
  }
});

const swiper3 = new Swiper(".swiper-kotatsu", {
  centeredSlides: true,
  slidesPerView: 1.85,
  spaceBetween: 20,
  loop: true,
  roundLengths: true,
  pagination: {
    el: ".pagination-kotatsu",
    clickable: true,
  },
  navigation: {
    nextEl: ".next-kotatsu",
    prevEl: ".prev-kotatsu",
  },
  breakpoints: {
    768: {
      slidesPerView: 4.3,
      spaceBetween: 30,
      centeredSlides: false,
      loop: false,
    }
  }
});

const swiper4 = new Swiper(".swiper-sofa", {
  centeredSlides: true,
  slidesPerView: 1.85,
  spaceBetween: 20,
  loop: true,
  roundLengths: true,
  pagination: {
    el: ".pagination-sofa",
    clickable: true,
  },
  navigation: {
    nextEl: ".next-sofa",
    prevEl: ".prev-sofa",
  },
  breakpoints: {
    768: {
      slidesPerView: 4.3,
      spaceBetween: 30,
      centeredSlides: false,
      loop: false,
    }
  }
});

const swiper5 = new Swiper(".swiper-type", {
  slidesPerView: 1,
  spaceBetween: 0,
  loop: true,
  roundLengths: true,
  navigation: {
    nextEl: ".next-type",
    prevEl: ".prev-type",
  },
});
